import actionTypes from '../../action-types'

export default (userId, id) => ({
  type: actionTypes.USER.USER_GROUP_RELATION_DELETE,
  payload: {
    userId,
    id,
  },
})
